import { PERPETUAL } from '@/constants/durations'
import { translate } from '@/utils/translations'

import priceFactory from "../price/priceFactory"

class PricingPanelVariant {
  constructor({
    id,
    isPrint,
    selectedVariantId,
    variant
  }) {
    const { duration, studentPrice } = variant

    const isSelected = id === selectedVariantId

    const isPerpetual = duration === PERPETUAL

    const conditionMap = {
      marketplace: translate('common.print_variants.marketplace'),
      new: translate('common.print_variants.new'),
      used: translate('common.print_variants.used'),
    }

    const printVariantDescription = variant => {
      if (variant.orderType === "rental") {
        return translate('common.print_variants.rental')
      } else {
        return conditionMap[variant.condition]
      }
    }

    const durationExpirationText = () => {
      if (isPrint) {
        return printVariantDescription(variant)
      }
      else if (isPerpetual) {
        return translate('purchase.buy_eTextbook')
      }
      else {
        return duration
      }
    }

    this.id = id,
    this.studentPrice = priceFactory.createPrice(
      'StudentPrice', { studentPrice }
    ).formattedAmount
    this.durationExpirationText = durationExpirationText()
    this.className = `variant${isSelected ? ' selected' : ''}`,
    this.fullVariant = variant
    this.isSelected = isSelected
  }
}

export default PricingPanelVariant
